import { render, staticRenderFns } from "./PwdForget.vue?vue&type=template&id=1bb02429&"
import script from "./PwdForget.vue?vue&type=script&lang=js&"
export * from "./PwdForget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports